/**
 * Compares the values of 2 form fields with special consideration for form multi select fields and checkboxes.
 * @param formValue
 * @param compareValue
 * @return {boolean}
 */
const areFieldValuesEqual = (formValue, compareValue) => {
  if (typeof formValue === 'undefined') {
    return false;
  }

  // Handle formValue when formValue is not an array,
  // returns true on null = null.
  if (formValue === compareValue) {
    return true;
  } else if (formValue === null) {
    return false;
  }

  // multi-select fields have array formValue; if we don't have an array,
  // convert to one so we can still loop through all values
  const formValues = formValue instanceof Array ? formValue : [formValue];
  for (const value of formValues) {
    if (value === compareValue) {
      return true;
    }
    // Checkboxes in redux-form toggle between true if checked, and (annoyingly)
    // either empty string or boolean false if they are unchecked
    if ((value === '' && compareValue === false) || (value === false && compareValue === '')) {
      return true;
    }
  }
  return false;
};

export { areFieldValuesEqual };
